import { ApiRequestContextData } from "@utils/api-config/types";

export function getWalletRequestContext(walletId?: string | null) {
	if (!walletId) {
		return null;
	}

	const wallets = App.state.rootStore.userAuthStore.userAccounts;
	const selectedWallet = wallets?.find((w) => w.id == walletId);

	if (!selectedWallet) {
		return null;
	}

	let user = App.state.rootStore.userAuthStore.user;

	if (!user) {
		return null;
	}

	if (user.id != selectedWallet.userId) {
		user = App.state.rootStore.userAuthStore.secondaryUser;
	}

	let token = App.state.rootStore.userAuthStore.shopUserToken;

	if (user?.isInternetUser) {
		token = App.state.rootStore.userAuthStore.onlineUserToken;
	}

	if (!token) {
		return null;
	}

	const requestMetaData: ApiRequestContextData = {
		agencyId: selectedWallet.agencyId,
		agencyKey: selectedWallet.agencyIdentifier,
		authToken: token,
		shopId: selectedWallet.shopId,
		userId: selectedWallet.userId,
		accountTypeId: selectedWallet.accountTypeId,
	};

	return requestMetaData;
}
